import Avatar from '@mui/material/Avatar';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

interface IStepTwoMessageBubbleProps {
    containerClass: string;
    bubbleDirection: 'left' | 'right';
    avatarAltText: string;
    avatarSrcUrl: string;
    messageName: string;
    messageTime: string;
    messageText: string;
}

const StepTwoMessageBubble = ({
    containerClass,
    bubbleDirection,
    avatarAltText,
    avatarSrcUrl,
    messageName,
    messageTime,
    messageText,
}: IStepTwoMessageBubbleProps) => (
    <Paper
        className={`buying-online-steps--communication-bubble ${containerClass}`}
        elevation={2}
        sx={{
            borderRadius: 1.5,
            [bubbleDirection === 'left' ? 'borderBottomLeftRadius' : 'borderBottomRightRadius']: 2,
        }}
    >
        <Stack
            direction="row"
            spacing={{ xs: 1.5, sm: 3 }}
            useFlexGap
            sx={{
                px: { xs: 2, sm: 3 },
                pt: { xs: 2, sm: 3 },
                pb: { xs: 2.5, sm: 3 },
            }}
        >
            <Avatar
                alt={avatarAltText}
                src={avatarSrcUrl}
                sx={{
                    width: { xs: '3rem', sm: '4rem' },
                    height: { xs: '3rem', sm: '4rem' },
                }}
            />
            <Stack>
                <Stack direction="row" spacing={0.5} useFlexGap sx={{ alignItems: 'center' }}>
                    <Typography variant="body2" sx={{ fontWeight: 700 }}>
                        {messageName}
                    </Typography>
                    <Typography variant="caption" color="textSecondary">
                        {messageTime}
                    </Typography>
                </Stack>
                <Typography variant="body1" sx={{ typography: { sm: 'bodyLarge' } }}>
                    {messageText}
                </Typography>
            </Stack>
        </Stack>
    </Paper>
);

export default StepTwoMessageBubble;
